"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const enums_1 = require("../enums");
class PromotionAttribute extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.AttributeType)),
    (0, base_models_1.Docs)({
        example: enums_1.AttributeType.ROI,
        description: 'Type of promotion attribute. See /v1/promotion-attributes with the allowed attributes',
    }),
    tslib_1.__metadata("design:type", String)
], PromotionAttribute.prototype, "key", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'High', description: 'Promotion attribute value.' }),
    tslib_1.__metadata("design:type", String)
], PromotionAttribute.prototype, "value", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({
        example: 100,
        description: `Promotion attribute priority relative to other attributes.<br>
This used in the score calculation: matched_promotion_attribute_priority * matched_segment_attribute_priority.`,
    }),
    tslib_1.__metadata("design:type", Number)
], PromotionAttribute.prototype, "priority", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        example: false,
        description: `Whether this promotion attribute is required or not.<br>
If set to true then atleast one attribute in the list of segments must match with the key value pair.`,
    }),
    tslib_1.__metadata("design:type", Boolean)
], PromotionAttribute.prototype, "required", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        example: false,
        description: `Defaults to false.<br>
If true and there is a segment with an attribute that matches with this key and value then the attached promotion will be marked as *not* matching.<br>
This is useful for example when you want to match a promotion with Essent customers, that have a 3 year contract, but not a flex contract.<br>
Then you will have an attribute key=contract_duration, value=flex, negate=true`,
    }),
    tslib_1.__metadata("design:type", Boolean)
], PromotionAttribute.prototype, "negate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({ maxDecimalPlaces: 0 }),
    (0, base_models_1.Docs)({
        example: 10,
        description: `
# Default
Defaults to the 'NULL' group.<br>
# Numbered Group
The group number specifies in which group this attribute should live.<br>
When matching a promotion with a list of segments, one of the things we do is look at each group individually.<br>
If all the required attributes in a group match with the attributes in a list of segments, that means that this promotion is a likely candidate to match.<br>
There are other requirements to match a promotion with attribute. For more information see /v3/nextbestoffer API.<br>
So group attributes together through this group number that form a logical set of attributes.<br>
For example all attributes in a single transition rule of campaign should have the same group number<br>
# NULL group
The 'NULL' group is a special group where we filter the promotion and the given query parameters.<br>
For example, if you create an attribute with key=brand,value=essent and nextBestInformational is called with query parameter ?brand=energiedirect,
it will not match with the promotion even when required=false`,
    }),
    tslib_1.__metadata("design:type", Number)
], PromotionAttribute.prototype, "group", void 0);
exports.default = PromotionAttribute;
